import { ISsrDebugEntry } from './ssrDebugTypes';

export const logSsrDebugEntriesToConsole = (entries: ISsrDebugEntry[], consolePrefix: string): void => {
    console.group(`${consolePrefix} SSR trace (${entries.length} entries)`);
    entries.forEach((entry) => {
        console.groupCollapsed(`${consolePrefix} ${entry.label}`);
        console.log(new Date(entry.timestamp).toISOString());
        if (entry.data !== undefined) {
            console.log(entry.data);
        }
        console.groupEnd();
    });
    console.groupEnd();
};
